const VALID_VIDEO_MIMETYPES = ["video/mpeg", "video/mp4", "video/webm"];
const VALID_IMAGE_MIMETYPES = ["image/gif", "image/jpeg", "image/png"];

const VALID_MIMETYPES = [...VALID_IMAGE_MIMETYPES, ...VALID_VIDEO_MIMETYPES];

const DEFAULT_CONTENT_DURATION = 15 * 1000;

const MODAL_CREATE_CONTENT_GROUP = "modal--create-content-group";
const MODAL_CREATE_FOLDER = "modal--create-folder";
const MODAL_MOVE_TO_FOLDER = "modal--move-to-folder";

const MEDIA_LIBRARY_MODALS = [
  MODAL_CREATE_CONTENT_GROUP,
  MODAL_CREATE_FOLDER,
  MODAL_MOVE_TO_FOLDER,
];

const MEDIA_TABLE_FILTER_TAG = "tag";
const MEDIA_TABLE_FILTER_FOLDER = "folderName";
const MEDIA_TABLE_FILTER_TYPE = "friendlyType";

// NOTE: These constants are consistent with constants used in both STEM and
// the api, so beware when changing them.
const MEDIA_ENTRY_APPLICATION = "application";
const MEDIA_ENTRY_CONTENT_GROUP = "content_group";
const MEDIA_ENTRY_FOLDER = "folder";
const MEDIA_ENTRY_USER_CONTENT = "content";
const MEDIA_ENTRY_WEBPAGE = "webpage";

const DYNAMIC_CONTENT_TYPES = [MEDIA_ENTRY_APPLICATION, MEDIA_ENTRY_WEBPAGE];

const STATIC_CONTENT_TYPES = [
  MEDIA_ENTRY_CONTENT_GROUP,
  MEDIA_ENTRY_USER_CONTENT,
];

const ALL_CONTENT_TYPES = DYNAMIC_CONTENT_TYPES.concat(STATIC_CONTENT_TYPES);

const ARCHIVE_STATUS_CHILDREN = "media-entry-children-archived";
const ARCHIVE_STATUS_ENTRY = "media-entry-archived";

const ROOT_URL = "/v2/strategies";
const BETA_ROOT_URL = "/beta/strategies";
const MEDIA_LIBRARY_URL = `${ROOT_URL}/media-library`;

export {
  ALL_CONTENT_TYPES,
  ARCHIVE_STATUS_CHILDREN,
  ARCHIVE_STATUS_ENTRY,
  BETA_ROOT_URL,
  DEFAULT_CONTENT_DURATION,
  DYNAMIC_CONTENT_TYPES,
  MEDIA_ENTRY_APPLICATION,
  MEDIA_ENTRY_CONTENT_GROUP,
  MEDIA_ENTRY_FOLDER,
  MEDIA_ENTRY_USER_CONTENT,
  MEDIA_ENTRY_WEBPAGE,
  MEDIA_LIBRARY_MODALS,
  MEDIA_LIBRARY_URL,
  MEDIA_TABLE_FILTER_FOLDER,
  MEDIA_TABLE_FILTER_TAG,
  MEDIA_TABLE_FILTER_TYPE,
  MODAL_CREATE_CONTENT_GROUP,
  MODAL_CREATE_FOLDER,
  MODAL_MOVE_TO_FOLDER,
  ROOT_URL,
  STATIC_CONTENT_TYPES,
  VALID_IMAGE_MIMETYPES,
  VALID_MIMETYPES,
  VALID_VIDEO_MIMETYPES,
};
